import { req } from "@/api/api_request";

// 获取巡查任务列表
export function getPatrolTaskList({
  group_id,
  page,
  size,
  start_time,
  end_time,
  road_id
}) {
  let url = `inspection/get-task-list?group_id=${group_id}`;
  if (page) {
    url += `&page=${page}`;
  }
  if (size) {
    url += `&size=${size}`;
  }
  if (start_time) {
    url += `&start_time=${start_time}`;
  }
  if (end_time) {
    url += `&end_time=${end_time}`;
  }
  if (road_id) {
    url += `&road_id=${road_id}`;
  }
  return req.get(url);
}

// 新建巡查任务
export function addPatrolTask(params) {
  let url = `inspection/add-task`;
  return req.post(url, params);
}

// 编辑巡查任务
export function updatePatrolTask(params) {
  let url = `inspection/update-task`;
  return req.post(url, params);
}

// 删除巡查任务
export function deletePatrolTask(id) {
  let url = `inspection/delete-task?task_id=${id}`;
  return req.post(url);
}

// 推送归档
export function archivePushTask(id) {
  let url = `inspection/data-push-task?task_id=${id}`;
  return req.post(url);
}
